import * as _ from 'lodash';
import type { Column, Formatter } from 'slickgrid';
export * from './badge';
export * from './bool';
export * from './cellclass';
export * from './chain';
export * from './checkbox';
export * from './clicksink';
export * from './command';
export * from './date';
export * from './datetime';
export * from './filesize';
export * from './getvalue';
export * from './join';
export * from './jsonify';
export * from './link';
export * from './mapvalue';
export * from './template';
export * from './text';
export * from './time';

import { badge } from './badge';
import { bool } from './bool';
import { cellclass } from './cellclass';
import { chain } from './chain';
import { checkbox } from './checkbox';
import { clicksink } from './clicksink';
import { command } from './command';
import { date } from './date';
import { datetime } from './datetime';
import { filesize } from './filesize';
import { getvalue } from './getvalue';
import { join } from './join';
import { jsonify } from './jsonify';
import { link } from './link';
import { mapvalue } from './mapvalue';
import { template } from './template';
import { text } from './text';
import { time } from './time';

const ALL: Dictionary<FormatterFactory> = {
  badge,
  bool,
  cellclass,
  chain,
  checkbox,
  clicksink,
  command,
  date,
  datetime,
  filesize,
  getvalue,
  join,
  jsonify,
  link,
  mapvalue,
  template,
  text,
  time,
};

export interface FormatterFactory {
  <T>(options?: any): Formatter<T>;
}

export function getFormatterFactory(name: string) {
  const result = ALL[name];

  if (!result) {
    throw new TypeError(`invalid column formatter name: ${name}`);
  }

  return result;
}

export function registerFormatter(name: string, factory: FormatterFactory) {
  if (ALL[name]) {
    throw new Error(`Formatter already exists: ${name}`);
  }

  ALL[name] = factory;
}

export function getColumnFormatter<T>(column: Column<T>): Formatter<T> {
  if (_.isString(column.formatter)) {
    return getFormatterFactory(column.formatter)({});
  }

  // Multiple formatters
  if (!_.isFunction(column.formatter) && _.isArray(column.formatter)) {
    return chain({ formatters: column.formatter });
  }

  // Single formatter by config object
  if (!_.isFunction(column.formatter) && _.isObject(column.formatter)) {
    return getFormatterFactory(column.formatter['name'])(column.formatter);
  }

  if (column.formatter == null) {
    return getDefaultFormatter(column);
  }

  return column.formatter;
}

function getDefaultFormatter<T>(column: Column<T>): Formatter<T> {
  if (column.type === 'date-time' || column.format === 'date-time') {
    return datetime({});
  }

  return column.formatter as unknown as Formatter<T>;
}

export function getAllFormatters() {
  return { ...ALL };
}
